import { useEffect, useState } from "react";
import { Card, CardContent, Typography } from "@mui/material";
import { PieChart } from "@mui/x-charts/PieChart";
import apiService from "../../../../../../service/Api";

/* =====================
   TYPES
===================== */

interface StreamReadinessSummary {
  ready: number;
  partial: number;
  not_ready: number;
  total: number;
}

interface StreamReadinessResponse {
  summary: StreamReadinessSummary;
}

/* =====================
   COMPONENT
===================== */

export default function StreamingReadinessWidget() {
  const [data, setData] = useState<
    { id: number; value: number; label: string; color: string }[]
  >([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function fetchReadiness() {
      try {
        const response = await apiService.get<StreamReadinessResponse>(
          "/api/venues/dashboard/stream-readiness/"
        );

        const summary = response.data?.summary;
        if (!summary) return;

        setData([
          {
            id: 0,
            value: summary.ready,
            label: "Ready",
            color: "#2e7d32", // green
          },
          {
            id: 1,
            value: summary.partial,
            label: "Partial",
            color: "#f9a825", // amber
          },
          {
            id: 2,
            value: summary.not_ready,
            label: "Not Ready",
            color: "#d32f2f", // red
          },
        ]);
      } catch (error) {
        console.error("Error fetching stream readiness:", error);
      } finally {
        setLoading(false);
      }
    }

    fetchReadiness();
  }, []);

  if (loading) return <Typography>Loading...</Typography>;
  if (!data.length) return <Typography>No data available</Typography>;

  return (
    <Card sx={{ height: "100%", borderRadius: 3, width: "100%" }}>
      <CardContent>
        <Typography variant="h6" gutterBottom>
          Streaming Readiness
        </Typography>

        <PieChart
          series={[
            {
              data,
              highlightScope: { fade: "global", highlight: "item" },
              faded: { innerRadius: 30, additionalRadius: -10 },
            },
          ]}
          height={280}
        />
      </CardContent>
    </Card>
  );
}
